import { ApiService } from '../../services/api.service';
import { TemplateService } from '../../services/template.service';
import { ActivatedRoute } from "@angular/router";
var SaleTaxComponent = (function () {
    function SaleTaxComponent(apiService, template, route) {
        this.apiService = apiService;
        this.template = template;
        this.route = route;
        this.step = 0;
        this.items = [
            { label: 'รายการที่ยังไม่บันทึก' },
            { label: 'รายการที่บันทึกแล้ว' }
        ];
    }
    SaleTaxComponent.prototype.ngOnInit = function () {
    };
    return SaleTaxComponent;
}());
export { SaleTaxComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/saletax.component.ts.pre-build-optimizer.js